import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo4/palafito.png";
import Imagen2 from "../../../images/modulo4/sierralluvia.png";
import Imagen3 from "../../../images/modulo4/viento.png";
import Imagen4 from "../../../images/modulo4/sol.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo4 } from "../../../routes/Module4";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import InputRadioButton from "../../../components/InputRadioButton";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo4/Actividad 4.mp3";

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option2" },
    ans2: { value: "", valid: "", correctValue: "option1" },
    ans3: { value: "", valid: "", correctValue: "option1" },
    ans4: { value: "", valid: "", correctValue: "option2" },
  });

  const infoUnidad = modulo4.content[0];
  const infoAct = modulo4.content[0].activities[3];
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title:
        modulo4.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo4.content[0].activities[4].name}`,
    linkNext: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[4].path}`,
    titlePrev: `${modulo4.content[0].activities[2].name}`,
    linkPrev: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[2].path}`,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswer = (label, value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    });
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title} - ${infoAct.name}`,
    name: modulo4.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo4.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">Actividad 4</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          Nuestras casas y nuestra vestimenta se adaptan al territorio y al
          clima.
        </li>
        <li>Marca la opción correcta para cada caso.</li>
        <li>
          Luego, piensa. ¿Cómo te adaptas al clima del lugar en el que vives?
        </li>
      </ul>

      <div className="row mt-5">
        <div className="col-md-6 col-xs-12 mb-4">
          <img src={Imagen1} alt="Familia" className="img-fluid mb-2" />
          <div className="ms-3">
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option1"
              text="El agua del río entra en la casa."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option2"
              text="El agua del río corre bajo la casa."
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
        <div className="col-md-6 col-xs-12 mb-5">
          <img src={Imagen2} alt="Familia" className="img-fluid mb-2" />
          <div className="ms-3">
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option1"
              text="El agua de la lluvia resbala por el techo."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option2"
              text="El agua de la lluvia se acumula en el techo."
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
        <div className="col-md-6 col-xs-12 mb-5">
          <img src={Imagen3} alt="Familia" className="img-fluid mb-2" />
          <div className="ms-3">
            <InputRadioButton
              ans={answers.ans3}
              label="ans3"
              value="option1"
              text="La casaca interrumpe el paso del viento."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans3}
              label="ans3"
              value="option2"
              text="La casaca deja pasar el viento."
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
        <div className="col-md-6 col-xs-12 mb-5">
          <img src={Imagen4} alt="Familia" className="img-fluid mb-2" />
          <div className="ms-3">
            <InputRadioButton
              ans={answers.ans4}
              label="ans4"
              value="option1"
              text="El sol pasa a través del sombrero."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans4}
              label="ans4"
              value="option2"
              text="El sombrero protege a Pepe del sol."
              handleAnswer={handleAnswer}
            />
          </div>
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo4.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y lea las opciones. Pida
          descripciones de lo que ven. Ayude a resolver la actividad y dialoguen
          sobre las respuestas. Destaque en cada caso cómo las casas y la
          vestimenta se adaptan al territorio y el clima.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
